module.exports = __webpack_public_path__ + "img/ai.a47c1c11.png";